export const COMPONENT_NAME = 'MenuNavLibras';

export const AutoactivateOptions = {
  FALSE: 'false',
  START: 'start',
  EXACT: 'exact',
  PATH: 'path',
};
